import React from 'react';
import SeatComponent from './SeatComponent';

const BusLayout = ({ rwType, seatLeft = [], seatRight = [] }) => {
    const renderSeatWithContainer = (seat, key) => (
        <div
            key={key}
            className={`seat-container`}
        >
            <SeatComponent 
                seat={seat} 
                isSelected={seat.isSelected}
                onSelect={seat.onSelect}
            />
        </div>
    );

    const render1x1Layout = () => (
        <div className="grid grid-cols-2 gap-5">
            <div className="left 1x1">
                {seatLeft.map((seat, index) => (
                    <SeatComponent 
                        key={seat.id || `left-${index}`} 
                        seat={seat}
                        isSelected={seat.isSelected}
                        onSelect={seat.onSelect}
                    />
                ))}
            </div>
            <div className="right 1x1">
                {seatRight.map((seat, index) => (
                    <SeatComponent 
                        key={seat.id || `right-${index}`} 
                        seat={seat}
                        isSelected={seat.isSelected}
                        onSelect={seat.onSelect}
                    />
                ))}
            </div>
        </div>
    );

    // 1x2 Layout
    const render1x2Layout = () => (
        <div className="grid grid-cols-3 gap-5">
            <div className="left 1x2 col-span-1 grid grid-cols-1">
                {seatLeft.map((seat, index) => (
                    <SeatComponent 
                        key={seat.id || `left-${index}`} 
                        seat={seat}
                        isSelected={seat.isSelected}
                        onSelect={seat.onSelect}
                    />
                ))}
            </div>
            <div className="right 1x2 col-span-2 grid grid-cols-2">
                {seatRight.map((seat, index) => renderSeatWithContainer(seat, seat.id || `right-${index}`))}
            </div>
        </div>
    );

    // 2x2 Layout
    const render2x2Layout = () => (
        <div className="grid grid-cols-2 gap-5">
            <div className="left 2x2 grid grid-cols-2 gap-1">
                {seatLeft.map((seat, index) => renderSeatWithContainer(seat, seat.id || `left-${index}`))}
            </div>
            <div className="right 2x2 grid grid-cols-2 gap-1 items-center">
                {seatRight.map((seat, index) => renderSeatWithContainer(seat, seat.id || `right-${index}`))}
            </div>
        </div>
    );

    // 2x3 Layout
    const render2x3Layout = () => (
        <div className="grid grid-cols-5 gap-5">
            <div className="left 2x3 col-span-2 grid grid-cols-2 gap-1">
                {seatLeft.map((seat, index) => renderSeatWithContainer(seat, seat.id || `left-${index}`))}
            </div>
            <div className="right 2x3 col-span-3 grid grid-cols-3 gap-1">
                {seatRight.map((seat, index) => renderSeatWithContainer(seat, seat.id || `right-${index}`))}
            </div>
        </div>
    );

    const renderLayout = () => {
        switch (rwType) {
            case '1x1':
                return render1x1Layout();
            case '1x2':
                return render1x2Layout();
            case '2x2':
                return render2x2Layout();
            case '2x3':
                return render2x3Layout();
            default:
                return <div className="text-center p-4 text-gray-500">No layout specified</div>;
        }
    };

    return (
        <div className="bus-layout-wrapper">
            {renderLayout()}
        </div>
    );
};

export default BusLayout;